/* eslint-disable react/prop-types */
import * as React from "react";
import { MoreHorizontal } from "lucide-react";
import { ChevronLeft } from "lucide-react";
import { ChevronRight } from "lucide-react";

// Utility function to concatenate class names
function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Pagination = ({ className, ...props }) => (
  <nav
    role="navigation"
    aria-label="pagination"
    className={cn("tw-flex tw-justify-end tw-p-0", className)}
    {...props}
  />
);
Pagination.displayName = "Pagination";

const PaginationContent = React.forwardRef(({ className, ...props }, ref) => (
  <ul
    ref={ref}
    className={cn("tw-flex tw-flex-row tw-items-center tw-gap-1", className)}
    {...props}
  />
));
PaginationContent.displayName = "PaginationContent";

const PaginationItem = React.forwardRef(({ className, ...props }, ref) => (
  <li ref={ref} className={cn("tw-list-none", className)} {...props} />
));
PaginationItem.displayName = "PaginationItem";

const PaginationLink = ({
  className,
  isActive,
  size = "icon",
  children,
  ...props
}) => (
  <a
    aria-current={isActive ? "page" : undefined}
    className={cn(
      "tw-no-underline tw-text-black tw-inline-flex tw-items-center tw-justify-center tw-whitespace-nowrap tw-rounded-full tw-text-sm tw-font-medium tw-ring-offset-background tw-transition-colors focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2 disabled:tw-pointer-events-none disabled:tw-opacity-50",
      isActive
        ? "tw-bg-[#BEC663] tw-rounded-full tw-text-white "
        : "tw-bg-transparent hover:tw-bg-accent hover:tw-text-accent-foreground",
      size === "default" ? "tw-h-10 tw-px-4 tw-py-2" : "tw-h-9 tw-w-9",
      className
    )}
    {...props}
  >
    {children ? children : <span className="tw-sr-only">Pagination link</span>}
  </a>
);
PaginationLink.displayName = "PaginationLink";

const PaginationPrevious = ({ className, ...props }) => (
  <PaginationLink
    aria-label="Go to previous page"
    size="default"
    className={cn("tw-gap-1 tw-pl-2.5", className)}
    {...props}
  >
    <ChevronLeft className="tw-text-xs tw-text-black/50 hover:tw-text-black" />
    {/* <span>Prev</span> */}
  </PaginationLink>
);
PaginationPrevious.displayName = "PaginationPrevious";

const PaginationNext = ({ className, ...props }) => (
  <PaginationLink
    aria-label="Go to next page"
    size="default"
    className={cn("tw-gap-1 tw-pr-2.5", className)}
    {...props}
  >
    <ChevronRight className="tw-text-xs tw-text-black/50 hover:tw-text-black" />
    {/* <span>Next</span> */}
  </PaginationLink>
);
PaginationNext.displayName = "PaginationNext";

const PaginationEllipsis = ({ className, ...props }) => (
  <span
    aria-hidden
    className={cn(
      "tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center",
      className
    )}
    {...props}
  >
    <MoreHorizontal className="tw-h-4 tw-w-4" />
    <span className="tw-sr-only">More pages</span>
  </span>
);
PaginationEllipsis.displayName = "PaginationEllipsis";

export {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
};
